import { ProductType, ResultType, selectResultType } from "features/searchResultsFacets";
import { store$ } from "@redux/store";
import { distinctUntilChanged, map } from "rxjs";
import { routingSelectors, buildNewUrl } from "features/routing";
import fastdom from "fastdom";
import ResultTab from "./resultTab";
import UrlSubdirectoryTypes from "../../enums/urlSubdirectoryTypes";

const { urlComponentsSelector } = routingSelectors;

export default class CommunitiesTab extends ResultTab {
  constructor() {
    super();
    this.qaAttribute = 'filters-result-type-communities';
    this.subdirectory = UrlSubdirectoryTypes.Communities.toString();
    this.content = 'Communities';
    this.resultType = ResultType.Communities.toString();
    this.productType = ProductType.Communities.toString();
    this.googleAnalyticsTrackingClass = 'tagmanager_communitiestab';
    this.tabCLass = 'nhs-n1-c-button__tab nhs-n1-c-button__tab--light';

    const resultTypeChange$ = store$.pipe(
      map(selectResultType),
      map((resultType) => this.resultType === resultType),
      distinctUntilChanged(),
    );
    resultTypeChange$.subscribe(this.setIsActive.bind(this));

    const urlSegmentsChange$ = store$.pipe(
      map(urlComponentsSelector),
      distinctUntilChanged(),
    );

    urlSegmentsChange$.subscribe(this.updateUrlSegments.bind(this));
  }

  updateUrlSegments(componentsUrl) {
    const { urlSubdirectory, urlCoordinatesQueryString, urlLocation, urlQueryString, urlBuilderName } = componentsUrl;
    const newSubdirectory = this.updateSubdirectory(urlSubdirectory);
    const urlConfiguration = {
      urlSubdirectory: newSubdirectory,
      urlCoordinatesQueryString,
      urlLocation,
      urlQueryString,
      urlBuilderName,
    }

    this.url = buildNewUrl(urlConfiguration);
    this.updateUrl(this.url);
    fastdom.mutate(() => {
      const tabElement = this.getNode();
      if (tabElement) {
        tabElement.href = this.url;
      }
    });
  }

  updateSubdirectory(urlSubdirectory) {
    switch (urlSubdirectory) {
      case UrlSubdirectoryTypes.Homes.toString():
      case UrlSubdirectoryTypes.Builders.toString():
      case UrlSubdirectoryTypes.FloorPlans.toString():
      case UrlSubdirectoryTypes.ModelHomes.toString():
        return this.subdirectory;

      case UrlSubdirectoryTypes.CondosAndTownHomes.toString():
      case UrlSubdirectoryTypes.CondoDevelopment.toString():
        return UrlSubdirectoryTypes.CondoDevelopment.toString();

      case UrlSubdirectoryTypes.SingleFamilyHomes.toString():
      case UrlSubdirectoryTypes.SingleFamilyCommunities.toString():
        return UrlSubdirectoryTypes.SingleFamilyCommunities.toString();

      default:
        return this.subdirectory;
    }
  }

  getHTML() {
    const classesList = [this.googleAnalyticsTrackingClass, this.tabCLass];
    if (this.isActive) {
      classesList.push('nhs-n1-c-button__tab--light-active');
    }

    return `<a href='${this.url}' class='${classesList.join(' ')}' data-result-type='${this.resultType}'
            data-product-type='${this.productType}' data-qa=${this.qaAttribute}>${this.content}</a>`;
  }
}
